import {
  takeLatest, put, call, all,
} from 'redux-saga/effects';
import * as actions from '@actions';
import FhqTemplateService from '@rootCommon/services/fhq-template-service';
import { IdType } from '@rootTypes/common';
import { FhqInviteTemplates } from '@rootTypes/fhq';
import { InviteTemplate } from '@rootTypes/fhq-invite-template';
import { AxiosError } from 'axios';
import { SagaGenerator } from './index';

// fetch
function* fetchFhqTemplatesAsync(action: { payload: IdType[] }) {
  try {
    const inviteTemplates: InviteTemplate[][] = yield all(action.payload
      .map((siteFhqId) => call(FhqTemplateService.getAdminInviteTemplates, siteFhqId)));

    const fhqInviteTemplates: FhqInviteTemplates[] = action.payload
      .map((siteFhqId, index) => ({ siteFhqId, inviteTemplates: inviteTemplates[index] }));

    yield put(actions.fetchFhqTemplates.success(fhqInviteTemplates));
  } catch (e) {
    const error = e as AxiosError | Error;
    yield put(actions.fetchFhqTemplates.failure(error));
  }
}

function* watchFetchFhqTemplates() {
  yield takeLatest(actions.fetchFhqTemplates.request, fetchFhqTemplatesAsync);
}

// all
function* watchFhqTemplates(): SagaGenerator {
  yield all([watchFetchFhqTemplates()]);
}

export default watchFhqTemplates;
